/* eslint-disable max-len */
import { convertToCurrentGMT, formatDate, getDateRemainFromNow, addAvatarText } from '_utils/function'
import React, { useState } from 'react'
import { formatUnixToDate } from '_utils/formatNumber'
import { Link } from 'react-router-dom'
import { FiLink, FiShare2 } from 'react-icons/fi'
import { useModal } from '_hooks/useModal'
import useShareLinkEvent from '_hooks/useShareLinkEvent'
import useUserRole from '_hooks/useUserRole'
import ImageSlider from '_components/ImageSlider'
import ModalExternalLink from '../../components/ModalExternalLink'

const EventSummaryCard = ({ eventDetail, groupDetail, collectionTimeStart, collectionTimeEnd,
  isAllowManageEvent
}) => {
  const { userInfo } = useUserRole()
  const isCreator = Boolean(
    userInfo?.id && eventDetail?.createdUserId && String(userInfo.id) === String(eventDetail.createdUserId)
  )
  const [isCopied, setIsCopied] = useState(false)
  const { handleShare, isLoading: isLoadingShare } = useShareLinkEvent()
  const totalBuy = eventDetail?.products?.reduce((pre, cur) => pre + (cur.orderCount || 0), 0) || 0

  const listLinkModal = useModal()

  const onClickShare = () => {
    if (isLoadingShare || isCopied) return
    handleShare(eventDetail?.id, (url) => {
      navigator.clipboard.writeText(url)
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    })
  }

  return (
    <div className="edv2-card">
      <div className="edv2-card__head">
        {eventDetail?.createdUserPhotoUrl ? (
          <img
            className="edv2-avatar"
            src={eventDetail?.createdUserPhotoUrl}
            alt={eventDetail?.title || ''}
          />
        ) : (
          <div className="edv2-avatar">{addAvatarText(groupDetail?.group?.name || eventDetail?.createdUserName || 'EV')}</div>
        )}
        <div className="edv2-card__head-info">
          <h3>{eventDetail?.groupName}</h3>
          <p>Created by {eventDetail?.createdUserName}</p>
        </div>
        <div className="edv2-card__head-meta">
          {isAllowManageEvent && (
            <Link to={`/event/manage-orders?eventId=${eventDetail.id}`} className="edv2-manage-link">
              MANAGE
            </Link>
          )}
          <span className="edv2-days-left">
            {getDateRemainFromNow(convertToCurrentGMT(eventDetail.closingTime))} left
          </span>
          <span className="edv2-buy-pill">{totalBuy} BUY</span>
        </div>
      </div>

      <ImageSlider
        images={eventDetail?.photoUrls}
        alt={eventDetail?.title}
      />

      <div className="edv2-card__body">
        <h4>{eventDetail?.title}</h4>
        <p className="edv2-description">{eventDetail?.description}</p>

        <div className="edv2-info-row">
          <span className="edv2-info-label">Event open:</span>
          <span className="edv2-info-value">
            {formatUnixToDate(eventDetail?.createdAt)}
          </span>
        </div>
        <div className="edv2-info-row">
          <span className="edv2-info-label">Event close:</span>
          <span className="edv2-info-value">
            {formatDate({ date: convertToCurrentGMT(eventDetail.closingTime) })}
          </span>
        </div>
        <div className="edv2-info-row">
          <span className="edv2-info-label">Collection:</span>
          <span className="edv2-info-value">
            {formatDate({ date: convertToCurrentGMT(eventDetail.pickupTime) })}
            {collectionTimeStart && collectionTimeEnd ? ` (${collectionTimeStart} - ${collectionTimeEnd})` : ''}
          </span>
        </div>
        {eventDetail?.pickupAddress && (
          <div className="edv2-info-row">
            <span className="edv2-info-label">Address:</span>
            <span className="edv2-info-value">{eventDetail?.pickupAddress}</span>
          </div>
        )}
      </div>
      {(eventDetail?.extraFields?.list?.length > 0 || isCreator) && (
        <div className="edv2-card__footer">
          <div className="edv2-footer-left">
            {eventDetail?.extraFields?.list?.length === 1 && eventDetail?.extraFields?.list[0] && (
              <div className="edv2-footer-link-wrapper">
                <FiLink className="edv2-footer-link-icon" />
                <a
                  href={eventDetail?.extraFields?.list[0]?.value || '#'}
                  target="_blank"
                  rel="noreferrer"
                  className="edv2-footer-link"
                >
                  {eventDetail?.extraFields?.list[0]?.name || ''}
                </a>
              </div>
            )}
            {eventDetail?.extraFields?.list?.length > 1 && (
              <div className="edv2-footer-link-wrapper" onClick={listLinkModal.toggleModal}>
                <FiLink className="edv2-footer-link-icon" />
                <span className="edv2-footer-link">
                  {eventDetail?.extraFields?.list?.length} Links
                </span>
              </div>
            )}
          </div>
          {isCreator && (
            <button
              type="button"
              className="edv2-footer-share-btn"
              aria-label="Share"
              onClick={onClickShare}
              disabled={isLoadingShare}
            >
              {isCopied ? <span className="edv2-footer-copied-text">Copied</span> : <FiShare2 />}
            </button>
          )}
        </div>
      )}

      <ModalExternalLink
        isOpen={listLinkModal.isOpen}
        toggle={listLinkModal.toggleModal}
        extraFields={eventDetail?.extraFields}
      />
    </div>
  )
}

export default EventSummaryCard
